import React from 'react';
import { useIntl } from 'react-intl';
import Html from 'components/html';

import { isModelContestBannerActive } from '../model-contest-banner/model-contest-banner.settings';

import EarningsRanking from './earnings-ranking';
import { config, testId } from './become-rich-banner.settings';
import messages from './become-rich-banner.i18n';
import styles from './become-rich-banner.module.scss';

const BecomeRichBanner: React.FunctionComponent<unknown> = () => {
  const { formatMessage } = useIntl();
  const translation = messages.pages.landing.becomeRichBanner.livejasmin;

  const renderEarningsRanking = React.useCallback(
    (ranking: 'gold' | 'silver' | 'bronze', rank: number, amount: number) => (
      <Html.div className={[styles.earningsRanking, styles[ranking]]}>
        <EarningsRanking ranking={ranking} rank={rank} amount={amount} />
      </Html.div>
    ),
    []
  );

  // TODO: Clean up after model contest ends. MSC-33176
  const isModelContestBannerVisible = isModelContestBannerActive();

  return (
    <Html.div
      className={[
        styles.becomeRichBanner,
        'px-0 py-12 py-md-20 w-100',
        !isModelContestBannerVisible && styles.withTopMargin,
      ]}
      testId={testId.component}
    >
      <Html.div className={[styles.title, 'mb-4 px-2']}>
        {formatMessage(translation.title, {
          b: (contents: React.ReactNode) => <Html.b className={styles.highlight}>{contents}</Html.b>,
        })}
      </Html.div>
      <Html.div className={[styles.description, 'mb-6 px-4']}>{formatMessage(translation.description)}</Html.div>
      <Html.div className={[styles.topModels, 'mb-8']}>
        {formatMessage(translation.topModels, {
          numModels: config.numTopModels,
        })}
      </Html.div>
      <Html.div className="d-flex align-items-center justify-content-center flex-wrap flex-lg-nowrap gap-3 gap-lg-6">
        {renderEarningsRanking('gold', config.earnings.gold.rank, config.earnings.gold.amount)}
        {renderEarningsRanking('silver', config.earnings.silver.rank, config.earnings.silver.amount)}
        {renderEarningsRanking('bronze', config.earnings.bronze.rank, config.earnings.bronze.amount)}
      </Html.div>
    </Html.div>
  );
};

export default BecomeRichBanner;
